// extracted by mini-css-extract-plugin
export default {"form":"ProductItemForm_form__P5QOx","inputsContainer":"ProductItemForm_inputsContainer__-boQy","outOfStockMessage":"ProductItemForm_outOfStockMessage__aVm9O"};